/* Homepage redesign (14/10/2026), from pulsio-homepage_29_2.html.
   Each section is a <div class="hr" data-hr> root and is set up on its own, so sections can be
   reordered or reloaded in the theme editor. Left out from the design file: the wheel-hijacking
   smooth scroll (it fought the basket drawer and the menu) and the code for parts the design no
   longer shows (spinning product hero, testimonials, accordion, counters, sticky button). */
(function () {
  'use strict';
  if (window.__hrHome) return;
  window.__hrHome = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- line-split headings ----------
     19/10 (Justyn "not silky smooth at times"): all headings are split together in three passes (lay out the
     words, measure them all, then build the lines), so the page is measured once rather than once per heading.
     Done one at a time it blocked a phone for about half a second while the hero was starting to animate. */
  function splitAll(els) {
    var jobs = els.map(function (el) {
      var raw = el.dataset.raw || el.textContent.replace(/\s+/g, ' ').trim();
      el.dataset.raw = raw;
      el.textContent = '';
      var probes = raw.split(' ').map(function (w) {
        var s = document.createElement('span');
        s.textContent = w; s.style.display = 'inline-block';
        return s;
      });
      probes.forEach(function (s, i) { el.appendChild(s); if (i < probes.length - 1) el.appendChild(document.createTextNode(' ')); });
      return { el: el, probes: probes };
    });
    jobs.forEach(function (j) {
      var lines = [], cur = null, lastTop = null;
      j.probes.forEach(function (s) {
        var t = Math.round(s.getBoundingClientRect().top);
        if (lastTop === null || Math.abs(t - lastTop) > 3) { cur = []; lines.push(cur); lastTop = t; }
        cur.push(s.textContent);
      });
      j.lines = lines;
    });
    jobs.forEach(function (j) {
      var el = j.el, st = /^H[1-4]$/.test(el.tagName) ? 0.15 : 0.10;
      el.textContent = '';
      j.lines.forEach(function (w, i) {
        var line = document.createElement('span'); line.className = 'line';
        var inner = document.createElement('i');
        inner.textContent = w.join(' ');
        inner.style.transitionDelay = (i * st).toFixed(2) + 's';
        line.appendChild(inner);
        el.appendChild(line);
      });
      el.__hrSplit = true;
    });
  }

  /* ---------- reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px 15% 0px', threshold: 0 }) : null;
  /* 21/10 (Justyn: "the home page goes blank if I scroll down fast while it loads", computer): a fast scroll outran the
     fade-ins (each started 15% inside the screen and took about a second), so most of the screen was empty. Fade-ins
     now start just before things come into view, and while you scroll fast everything on or above the screen is shown
     at once with no fade. */
  (function () {
    var st = document.createElement('style');
    st.textContent = 'html.hr-fast .hr .is-in,html.hr-fast .hr .is-in *{transition-duration:0s!important;transition-delay:0s!important}';
    document.head.appendChild(st);
    var lastY = window.scrollY, lastT = performance.now(), raf = 0, off = 0;
    function check() {
      raf = 0;
      var y = window.scrollY, t = performance.now(), v = Math.abs(y - lastY) / Math.max(16, t - lastT) * 1000;
      lastY = y; lastT = t;
      if (v < 2200) return;
      var root = document.documentElement, limit = window.innerHeight * 1.15;
      root.classList.add('hr-fast');
      $$('[data-hr] [data-split]:not(.is-in), [data-hr] .fade:not(.is-in), [data-hr] .masked:not(.is-in), [data-hr] .hr-logos__quote:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) { el.classList.add('is-in'); if (io) io.unobserve(el); }
      });
      /* fades already under way (rail cards with their staggered delay) jump to the end too */
      if (document.getAnimations) document.getAnimations().forEach(function (a) {
        var t = a.effect && a.effect.target;
        if (!a.transitionProperty || !t || !t.closest || !t.closest('[data-hr]')) return;
        var r = t.getBoundingClientRect();
        if (r.top < limit && r.bottom > -200) { try { a.finish(); } catch (e) {} }
      });
      clearTimeout(off); off = setTimeout(function () { root.classList.remove('hr-fast'); }, 350);
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
  })();

  function observe(root) {
    $$('[data-split], .fade, .masked, .hr-logos__quote', root).forEach(function (el) {
      if (el.closest('[data-hr-rail]') && !el.closest('.therapy__rail')) return; /* product rails reveal as a set */
      if (el.classList.contains('is-in')) return;
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- marquee (press quotes) ---------- */
  var marquees = [];
  var lastY = window.scrollY, vel = 0, scrollDir = 1, ticking = false;
  function buildMarquee(el) {
    var track = $('.mq-track', el), set = track && $('.mq-set', track);
    if (!set) return;
    $$('.mq-set[aria-hidden]', track).forEach(function (c) { c.remove(); });
    set.style.display = 'flex';
    set.style.flex = '0 0 auto';
    var w = set.getBoundingClientRect().width;
    if (!w) return;
    var copies = Math.ceil((el.offsetWidth * 2) / w) + 1;
    for (var i = 0; i < copies; i++) {
      var c = set.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    }
    var m = { el: el, track: track, w: w, speed: parseFloat(el.dataset.speed || '0.4'), rate: 1 };
    /* 19/10: the strip now runs as a browser animation (it keeps moving smoothly even while the page is busy
       loading); scrolling still speeds it up, by changing its playback rate. Same speed as before: speed px a frame. */
    if (!reduce && track.animate) {
      track.style.transform = '';
      m.anim = track.animate([{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-w) + 'px,0,0)' }],
        { duration: w / (m.speed * 60) * 1000, iterations: Infinity });
    }
    marquees.push(m);
  }
  /* scroll speed-up: the scroll position is noted as the page scrolls (nothing is measured), and a short loop
     eases the boost in and back out, running only while there is a boost to apply */
  var running = false;
  window.addEventListener('scroll', function () { lastY2 = window.scrollY; if (!running && marquees.length) { running = true; requestAnimationFrame(frame); } }, { passive: true });
  var lastY2 = lastY;
  /* 19/10 (Justyn "on mobile when you scroll this moves too fast"): a phone flick is 40px+ a frame, which hit the
     full boost (about 11x on the phone speed) straight away. Phones now top out at about 2.5x; computers unchanged. */
  var phoneMq = window.matchMedia('(max-width:860px)').matches;
  var BOOST_K = phoneMq ? 0.06 : 0.28, BOOST_MAX = phoneMq ? 1.35 : 9;
  function frame() {
    var d = lastY2 - lastY;
    if (Math.abs(d) > 0.5) scrollDir = d > 0 ? 1 : -1;
    vel += (d - vel) * 0.18;
    lastY = lastY2;
    var boost = Math.min(BOOST_MAX, Math.abs(vel) * BOOST_K);
    marquees = marquees.filter(function (m) { return m.el.isConnected; });
    marquees.forEach(function (m) {
      if (!m.anim) return;
      var r = (m.speed + boost) / m.speed;
      if (Math.abs(r - m.rate) > 0.02 || (boost === 0 && m.rate !== 1)) {
        m.rate = boost < 0.02 ? 1 : r;
        if (m.anim.updatePlaybackRate) m.anim.updatePlaybackRate(m.rate); else m.anim.playbackRate = m.rate;
      }
    });
    if (Math.abs(vel) > 0.05 || d !== 0) requestAnimationFrame(frame);
    else { vel = 0; running = false; marquees.forEach(function (m) { if (m.anim && m.rate !== 1) { m.rate = 1; if (m.anim.updatePlaybackRate) m.anim.updatePlaybackRate(1); else m.anim.playbackRate = 1; } }); }
  }

  /* ---------- carousels: arrows, mouse drag, progress bar ---------- */
  /* every carousel queues its progress-bar update here; once a frame they are all measured, then all updated,
     so the page is measured once rather than once per carousel (it was a big cost on phones while loading) */
  var syncQ = [], syncRaf = 0;
  function batchSync(job) {
    if (syncQ.indexOf(job) < 0) syncQ.push(job);
    if (!syncRaf) syncRaf = requestAnimationFrame(function () {
      syncRaf = 0;
      var q = syncQ; syncQ = [];
      var vals = q.map(function (j) { return j.read(); });
      q.forEach(function (j, i) { j.write(vals[i]); });
    });
  }
  function initRail(root) {
    var rail = $('[data-hr-rail]', root);
    if (!rail) return;
    var prev = $('[data-hr-prev]', root), next = $('[data-hr-next]', root), bar = $('[data-hr-bar]', root);
    var step = function () {
      var c = rail.querySelector('.card:not([hidden]), .therapy__item');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 16;
      return c ? c.getBoundingClientRect().width + gap : 300;
    };
    /* 19/10: measure first, then update; every carousel's bar is updated in the same frame (batchSync) */
    var job = {
      read: function () { return { sw: rail.scrollWidth, cw: rail.clientWidth, sl: rail.scrollLeft }; },
      write: function (v) {
        var max = v.sw - v.cw - 2;
        if (prev) prev.disabled = v.sl <= 2;
        if (next) next.disabled = v.sl >= max;
        if (bar && v.sw > 0) {
          var frac = Math.min(1, v.cw / v.sw);
          var travel = Math.max(0, v.sw - v.cw);
          var pos = travel > 0 ? v.sl / travel : 0;
          bar.style.width = (frac * 100).toFixed(2) + '%';
          bar.style.left = (pos * (100 - frac * 100)).toFixed(2) + '%';
        }
      }
    };
    var sync = function () { batchSync(job); };
    if (bar) dragBar(rail, bar);
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    dragScroll(rail);

    /* cards parked off the right edge never intersect, so reveal the set together */
    if ('IntersectionObserver' in window && !rail.classList.contains('therapy__rail')) {
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          rio.disconnect();
          $$('.fade, .masked', rail).forEach(function (el, k) {
            el.style.transitionDelay = Math.min(k * 0.05, 0.5) + 's';
            el.classList.add('is-in');
          });
        });
      }, { rootMargin: '0px 0px 15% 0px' }); /* 21/10: was -12%, start just before the rail shows so a fast scroll doesn't land on an empty row */
      rio.observe(rail);
    } else {
      $$('.fade, .masked', rail).forEach(function (el) { el.classList.add('is-in'); });
    }

    /* filter tabs above the rail */
    var tabs = $('[data-hr-tabs]', root);
    if (tabs) $$('.ctab', tabs).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.ctab', tabs).forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        var cat = btn.dataset.cat;
        $$('.card', rail).forEach(function (c) {
          c.hidden = cat !== 'all' && c.dataset.cat.split(',').map(function (x) { return x.trim(); }).indexOf(cat) < 0;
        });
        rail.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(sync, 50);
        fitCats();
      });
    });
    /* a carousel can open on one tab (default_tab setting, e.g. Accessories) */
    if (tabs && tabs.dataset.default) {
      var startCat = tabs.dataset.default;
      $$('.card', rail).forEach(function (c) {
        c.hidden = c.dataset.cat.split(',').map(function (x) { return x.trim(); }).indexOf(startCat) < 0;
      });
    }
    setTimeout(sync, 80);
  }

  /* the progress line under a carousel works as a scrollbar: drag the blue part,
     or click anywhere on the line to jump there */
  function dragBar(rail, bar) {
    var track = bar.parentElement;
    if (!track || track.__hrDrag) return;
    track.__hrDrag = true;
    var dragging = false, startX = 0, startLeft = 0;
    var travel = function () { return Math.max(0, rail.scrollWidth - rail.clientWidth); };
    var freeze = function (on) {
      rail.style.scrollSnapType = on ? 'none' : '';
      rail.style.scrollBehavior = on ? 'auto' : '';
    };
    track.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      e.preventDefault();
      freeze(true);
      var tr = track.getBoundingClientRect(), br = bar.getBoundingClientRect();
      if (e.clientX < br.left || e.clientX > br.right) {
        var pos = (e.clientX - tr.left - br.width / 2) / Math.max(1, tr.width - br.width);
        rail.scrollLeft = Math.max(0, Math.min(1, pos)) * travel();
      }
      dragging = true; startX = e.clientX; startLeft = rail.scrollLeft;
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var tw = track.getBoundingClientRect().width, bw = bar.getBoundingClientRect().width;
      rail.scrollLeft = startLeft + (e.clientX - startX) * travel() / Math.max(1, tw - bw);
    });
    var end = function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      freeze(false);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
  }

  function dragScroll(rail, onUp) {
    var down = false, x0 = 0, s0 = 0, moved = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; x0 = e.clientX; s0 = rail.scrollLeft; moved = 0;
      rail.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - x0;
      moved = Math.max(moved, Math.abs(d));
      rail.scrollLeft = s0 - d;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false; rail.classList.remove('is-drag');
      if (onUp) onUp();
    });
    rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- "A device for every moment" tabs ---------- */
  function initTabs(root) {
    var tabs = $$('.tab', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.getAttribute('aria-selected') === 'true') return;
        tabs.forEach(function (t) {
          var p = document.getElementById(t.getAttribute('aria-controls'));
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (p) p.hidden = !on;
        });
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (!panel) return;
        $$('[data-split], .masked', panel).forEach(function (el) { el.classList.remove('is-in'); });
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          $$('[data-split], .masked', panel).forEach(function (el) { el.classList.add('is-in'); });
        }); });
      });
      tab.addEventListener('keydown', function (e) {
        var vis = tabs.filter(function (t) { return !t.hidden; });
        var i = vis.indexOf(tab);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = vis[(i + (e.key === 'ArrowRight' ? 1 : vis.length - 1)) % vis.length];
          n.focus(); n.click();
        }
      });
    });
    /* "By moment / By body part" switch: shows that group's tabs and opens its first one */
    var modes = $$('.need__modebtn', root);
    modes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-pressed') === 'true') return;
        modes.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var mode = btn.dataset.mode, first = null;
        tabs.forEach(function (t) {
          var on = (t.dataset.group || 'moment') === mode;
          t.hidden = !on;
          if (on && !first) first = t;
        });
        if (first) { first.setAttribute('aria-selected', 'false'); first.click(); }
      });
    });
    /* phones show body parts only (14/10, Justyn): switch to that group on load; the switch itself is hidden in CSS */
    if (window.matchMedia('(max-width: 700px)').matches) {
      var bodyBtn = $('.need__modebtn[data-mode="body"]', root);
      if (bodyBtn && bodyBtn.getAttribute('aria-pressed') !== 'true') bodyBtn.click();
    }
  }

  /* the community reel rail lives in hr-ugc.js (17/10/2026) */

  /* ---------- Halo film: load once the section is near ---------- */
  function initLazyVideo(root) {
    $$('[data-hr-lazy-video]', root).forEach(function (v) {
      var go = function () {
        $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
        v.addEventListener('loadeddata', function () { if (v.videoWidth > 0) v.classList.add('is-live'); }, { once: true });
        v.load();
        if (!reduce) v.play().catch(function () {});
      };
      if (!('IntersectionObserver' in window)) return go();
      /* "tight" (therapy tiles): only once the tile itself is on screen, and never before the page has loaded */
      var tight = v.getAttribute('data-hr-lazy-video') === 'tight';
      var watch = function () {
        var hio = new IntersectionObserver(function (es) { es.forEach(function (e) {
          if (e.isIntersecting) { hio.disconnect(); go(); }
        }); }, { rootMargin: tight ? '0px' : '300px', threshold: tight ? 0.2 : 0 });
        hio.observe(tight ? v : (v.closest('section') || v));
      };
      if (tight && document.readyState !== 'complete') window.addEventListener('load', watch, { once: true }); else watch();
    });
  }

  /* ---------- Hero film: show the poster first, start the video once the page has loaded ---------- */
  function initAfterLoad(root) {
    $$('video[data-hr-after-load]', root).forEach(function (v) {
      if (reduce) return;
      var go = function () { setTimeout(function () { v.preload = 'auto'; v.play().catch(function () {}); }, 150); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    });
  }

  /* ---------- Card photo swipe (touch): keep the dots in step, hide the award off the first slide ---------- */
  /* Card photo swipe (touch screens): a controlled carousel, one photo per swipe, starts on the product render.
     Slide 0 is see-through so the render underneath shows. Native sideways scrolling was unreliable inside the card link. */
  function initGal(root) {
    $$('[data-hr-gal]', root).forEach(function (g) {
      var track = $('.card__gal-track', g), dots = $$('.card__gal-dots i', g), card = g.closest('.card');
      if (!track || !card) return;
      var n = track.children.length, i = 0, x0 = 0, y0 = 0, dx = 0, t0 = 0, mode = null, swiped = 0, back = 0;
      var w = function () { return g.clientWidth || 1; };
      var paint = function (frac, animate) {
        track.style.transition = animate ? 'transform .38s cubic-bezier(.22,.61,.36,1)' : 'none';
        track.style.transform = 'translate3d(' + (-frac * 100) + '%,0,0)';
        card.style.setProperty('--gp', Math.max(0, Math.min(1, frac)).toFixed(3));
      };
      var go = function (k) {
        i = Math.max(0, Math.min(n - 1, k));
        paint(i, true);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
        card.classList.toggle('is-gal-on', i > 0);
        clearTimeout(back); if (i > 0) back = setTimeout(function () { go(0); }, 6000);
      };
      var load = function () { $$('img', track).forEach(function (im) { im.loading = 'eager'; }); };
      g.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; dx = 0; t0 = Date.now(); mode = null; clearTimeout(back); load();
      }, { passive: true });
      g.addEventListener('touchmove', function (e) {
        var t = e.touches[0], mx = t.clientX - x0, my = t.clientY - y0;
        /* lean towards sideways: thumbs rarely move dead straight */
        if (!mode && (Math.abs(mx) > 6 || Math.abs(my) > 10)) mode = Math.abs(mx) > Math.abs(my) * 0.75 ? 'x' : 'y';
        if (mode !== 'x') return;
        e.preventDefault();
        dx = mx;
        var edge = (i === 0 && dx > 0) || (i === n - 1 && dx < 0);
        paint(i - (edge ? dx / 3 : dx) / w(), false);
      }, { passive: false });
      var end = function () {
        if (mode === 'x') {
          swiped = Date.now();
          var quick = Date.now() - t0 < 300 && Math.abs(dx) > 18; /* a short flick counts too */
          if (quick || Math.abs(dx) > w() * 0.15) go(i + (dx < 0 ? 1 : -1)); else go(i);
        } else if (i > 0) { back = setTimeout(function () { go(0); }, 6000); }
        mode = null; dx = 0;
      };
      g.addEventListener('touchend', end, { passive: true });
      g.addEventListener('touchcancel', end, { passive: true });
      /* a swipe must not open the product page */
      card.addEventListener('click', function (e) { if (Date.now() - swiped < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) {
          if (e.isIntersecting) load(); else if (i > 0) { clearTimeout(back); i = 0; paint(0, false); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === 0); }); card.classList.remove('is-gal-on'); }
        }); }, { rootMargin: '600px 0px' }).observe(card);
      }
    });
  }

  window.hrInitGal = function (el) { initGal(el); };

  /* ---------- "+" buttons: add simple products to the basket, then open UpCart ---------- */
  function openCart() {
    if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return true; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    return false;
  }
  function quickAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.hrAdd), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (typeof window.upcartRefreshCart === 'function') return Promise.resolve(window.upcartRefreshCart()).catch(function () {});
    }).then(function () {
      var waited = 0;
      (function wait() {
        if (openCart()) return;
        waited += 150;
        if (waited < 3000) { setTimeout(wait, 150); return; }
        window.location.href = root + 'cart';
      }());
    }).catch(function () {
      var a = btn.closest('a'); if (a) window.location.href = a.href;
    }).then(function () { btn.classList.remove('is-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.hr [data-hr-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    quickAdd(btn);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.hr [data-hr-add]');
    if (!btn) return;
    e.preventDefault(); quickAdd(btn);
  });

  /* ---------- in-page links (#moments, #halo): eased scroll like the design ---------- */
  var easeInOutQuart = function (t) { return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2; };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.hr a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (id === '#' || id.length < 2) return;
    var t = document.getElementById(id.slice(1));
    if (!t) return;
    e.preventDefault();
    var y = Math.max(0, t.getBoundingClientRect().top + window.scrollY - 90);
    if (reduce) { window.scrollTo(0, y); return; }
    var start = window.scrollY, delta = y - start, t0 = performance.now();
    (function step(now) {
      var p = Math.min(1, (now - t0) / 1200);
      window.scrollTo(0, start + delta * easeInOutQuart(p));
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  });

  /* ---------- card labels: whole labels only (19/10/2026) ----------
     Each card's label row is one line. A label that would not fit whole is hidden (with any after it) instead of
     being faded out. All rows are measured, then all are updated, so the page is measured once. Rows in hidden
     cards (filter tabs) have no width and are left until they show. */
  var fitRaf = 0;
  function fitCats() {
    if (fitRaf) return;
    fitRaf = requestAnimationFrame(function () {
      fitRaf = 0;
      var rows = $$('.hr .card__cats[data-fit]');
      rows.forEach(function (r) { $$('.is-cut', r).forEach(function (c) { c.classList.remove('is-cut'); }); });
      var jobs = rows.map(function (r) {
        var box = r.getBoundingClientRect();
        if (!box.width) return null;
        return { r: r, cut: $$('span', r).filter(function (c, i) { return i > 0 && c.getBoundingClientRect().right > box.right + 0.5; }) };
      });
      jobs.forEach(function (j) {
        if (!j) return;
        j.cut.forEach(function (c) { c.classList.add('is-cut'); });
        j.r.setAttribute('data-fitted', '');
      });
    });
  }
  window.addEventListener('load', fitCats);

  /* ---------- boot ---------- */
  function initRoot(root) {
    if (root.__hrInit) return;
    root.__hrInit = true;
    splitAll($$('[data-split]', root).filter(function (el) { return !el.__hrSplit; }));
    initRail(root);
    initTabs(root);
    initLazyVideo(root);
    initAfterLoad(root);
    initGal(root);
    $$('[data-mq]', root).forEach(buildMarquee);
    observe(root);
    if (root.querySelector('.phero')) {
      requestAnimationFrame(function () {
        $$('.phero [data-split], .phero .fade', root).forEach(function (el) { el.classList.add('is-in'); });
      });
    }
  }
  /* 21/10 (Justyn: "the home page crashes if the page hasn't loaded and I scroll down too fast"): this script loads
     last, and switching the fade-ins on hid everything not yet faded in, so on a slow phone whatever you had already
     scrolled to vanished and then faded back. If the page has already been scrolled, everything above the bottom of
     the screen is marked as shown first; only content further down still fades in. */
  function revealPassed() {
    if ((window.scrollY || 0) < 40) return;
    var limit = window.innerHeight;
    $$('[data-hr] [data-split], [data-hr] .fade, [data-hr] .masked, [data-hr] .hr-logos__quote').forEach(function (el) {
      if (el.getBoundingClientRect().top < limit) el.classList.add('is-in');
    });
  }
  function boot() {
    revealPassed();
    if (!reduce) document.documentElement.setAttribute('data-hr-anim', 'on');
    splitAll($$('[data-hr] [data-split]')); /* every heading on the page in one measuring pass */
    $$('[data-hr]').forEach(initRoot);
    fitCats();
    requestAnimationFrame(function () { document.documentElement.setAttribute('data-hr-loaded', '1'); });
  }
  function start() {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(boot, boot);
    else boot();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* ---------- header tone (from the design file): while scrolled, the floating bar reads
     the section behind it and switches to dark text and logo over light sections ---------- */
  (function navTone() {
    var host = document.querySelector('pulsio-header');
    if (!host) return;
    var DARK = '.phero,.pquotes,.need,.story,.duo,.halo,.pstrip,.quiz,footer,.footer,[class*="footer"]';
    var lum = function (el) {
      var n = el;
      while (n && n !== document.documentElement) {
        var c = getComputedStyle(n).backgroundColor, m = c.match(/[\d.]+/g);
        if (m && (m.length < 4 || +m[3] > 0.5)) return (+m[0]) + (+m[1]) + (+m[2]);
        n = n.parentElement;
      }
      return 720;
    };
    var tone = '';
    var read = function () {
      var bar = host.querySelector('.pulsio-header__bar'); if (!bar) return;
      var b = bar.getBoundingClientRect();
      var y = Math.max(1, b.top + b.height / 2), x = window.innerWidth / 2;
      var stack = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      var hit = null;
      for (var i = 0; i < stack.length; i++) { if (!host.contains(stack[i]) && !stack[i].closest('#preview-bar-iframe')) { hit = stack[i]; break; } }
      if (!hit) return;
      var dark = !!hit.closest(DARK) || (hit.tagName === 'VIDEO') || lum(hit) < 300; /* product images on light cards stay light (14/10) */
      var next = dark ? 'dark' : 'light';
      if (next !== tone) { tone = next; host.setAttribute('data-tone', tone); }
    };
    var raf = 0;
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; read(); }); }, { passive: true });
    window.addEventListener('resize', read);
    read();
  })();

  /* theme editor: set up a section again after it re-renders */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hr]', e.target).forEach(initRoot);
    fitCats();
  });

  /* re-split headings when the width changes (fonts and wrapping shift) */
  var rt, lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      var els = $$('.hr [data-split]');
      var was = els.map(function (el) { return el.classList.contains('is-in'); });
      splitAll(els);
      els.forEach(function (el, i) { if (was[i]) el.classList.add('is-in'); });
      fitCats();
    }, 250);
  });
})();
